/* @flow */

import React, { useState, useContext } from "react";
import { NavLink } from "react-router-dom";
import cn from "classnames";
import { useData } from "crustate/react";
import { CustomerData } from "data";
import { useTranslate } from "@awardit/react-use-translate";
import { StoreInfoContext } from "entrypoint/shared";
import { SubNavHeader, SubNavList } from "components/AppHeader/Small/SubNav";
import { mapBrands } from "helpers/appheader";
import ChevronIcon from "icons/chevron-small.svg";

import styles from "./styles.scss";

type Props = {
  closeHamburger: () => void,
  setHamburgerOpen: boolean => void,
  setSubNavOpen: boolean => void,
  closeMenu: () => void,
};

const Redeem = ({
  closeHamburger,
  setHamburgerOpen,
  setSubNavOpen,
  closeMenu,
}: Props): React$Node => {
  const t = useTranslate();
  const [thirdNav, setThirdNav] = useState(null);
  const [isClosing, setIsClosing] = useState(false);
  const { categories, brands, routes: {
    allProductsView,
    brandsView,
    redeemView,
  } } = useContext(StoreInfoContext);
  const customer = useData(CustomerData);
  const memberTargetList = customer.state === "LOGGED_IN" &&
  customer.data &&
  customer.data.memberTargetList &&
  customer.data.memberTargetList.list.length > 0 ?
    customer.data.memberTargetList.list :
    null;

  const categoriesFiltered = categories.filter(item => !memberTargetList ||
    memberTargetList.includes(item.awarditTargetId) ||
    !item.awarditTargetId);

  const closeThird = () => {
    setIsClosing(true);

    setTimeout(() => {
      setThirdNav(null);
      setIsClosing(false);
    }, parseInt(styles.animationDuration, 10));
  };

  return (
    <nav className={cn(styles.block)}>
      <SubNavHeader
        onBack={() => setSubNavOpen(false)}
        onClose={closeHamburger}
      >
        {(redeemView && redeemView.title) ?? ""}
      </SubNavHeader>
      <div className={styles.items}>
        {allProductsView && allProductsView.toggle !== undefined &&
        allProductsView.toggle && allProductsView.url && (
          <NavLink
            to={allProductsView.url}
            className={styles.item}
          >
            {allProductsView.title}
          </NavLink>
        )}

        <span
          className={styles.item}
          onClick={() => setThirdNav("categories")}
        >
          {t("HEADER.CATEGORIES")}
          <ChevronIcon />
        </span>

        <span
          className={styles.item}
          onClick={() => setThirdNav("brands")}
        >
          {t("HEADER.BRANDS")}
          <ChevronIcon />
        </span>
      </div>

      <nav className={cn(
        styles.categories,
        { [styles.active]: thirdNav === "categories" },
        { [styles.isClosing]: isClosing }
      )}
      >
        <SubNavHeader
          onClose={closeHamburger}
          onBack={() => closeThird()}
        >
          {t("HEADER.CATEGORIES")}
        </SubNavHeader>
        <SubNavList
          resourceType="categories"
          setHamburgerOpen={setHamburgerOpen}
          items={categoriesFiltered}
          onItemClick={() => {
            setThirdNav(null);
            closeMenu();
          }}
        />
      </nav>

      <nav className={cn(
        styles.brands,
        { [styles.active]: thirdNav === "brands" },
        { [styles.isClosing]: isClosing }
      )}
      >
        <SubNavHeader
          onClose={closeHamburger}
          onBack={() => closeThird()}
        >
          {t("HEADER.BRANDS")}
        </SubNavHeader>
        {brandsView && brandsView.url &&
          <SubNavList
            setHamburgerOpen={setHamburgerOpen}
            items={mapBrands(brandsView.url, brands)}
            resourceType="brands"
            onItemClick={() => {
              setThirdNav(null);
              closeMenu();
            }}
          />
        }
      </nav>
    </nav>
  );
};

export default Redeem;
